/** Stable cache key serialization for public fetches — leaf module (no imports). */

export function buildPublicCacheKey(parts) {
  return JSON.stringify(parts);
}
